import { render, staticRenderFns } from "./Attachement.vue?vue&type=template&id=ea17d4ea&scoped=true"
import script from "./Attachement.vue?vue&type=script&lang=js"
export * from "./Attachement.vue?vue&type=script&lang=js"
import style0 from "./Attachement.vue?vue&type=style&index=0&id=ea17d4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea17d4ea",
  null
  
)

export default component.exports